export default "__VITE_ASSET__d1b10021__"